import { Tooltip } from "antd";

export const renderInputBody = ({ t, disabled, body }) => {
  return disabled ? (
    <Tooltip title={t("You can't edit this")}>
      <div className="flex flex-1 flex-column">
        {body}
      </div>
    </Tooltip>
  ) : body;
}
